// shared/api/requests/artist/rating/post/hook.ts
import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { SubmitRatingParams } from './request';
import { submitRating } from './request';

export const useSubmitRatingMutation = (
  settings?: MutationSettings<SubmitRatingParams, typeof submitRating>
) =>
  useMutation({
    mutationKey: ['RatingsPost'],
    // mutationFn принимает ту же структуру, которую ожидает submitRating:
    // SubmitRatingParams === { params: SubmitRatingRequest; config?: AxiosRequestConfig }
    mutationFn: (variables: SubmitRatingParams) =>
      submitRating({
        params: variables.params,
        config: variables.config ?? settings?.config
      }),
    ...settings?.options
  });
